/**
 * 会員ランクの表示・スタンプカード上のネームプレート用スタイル。
 * サーバーは BRONZE / SILVER / GOLD / PLATINUM を返す。
 */

export type MemberRankKey = "BRONZE" | "SILVER" | "GOLD" | "PLATINUM";

export function parseMemberRankKey(rank: string | undefined | null): MemberRankKey {
  const u = String(rank || "")
    .trim()
    .toUpperCase();
  if (u === "PLATINUM" || u === "PLATINA") return "PLATINUM";
  if (u === "GOLD") return "GOLD";
  if (u === "SILVER") return "SILVER";
  if (u === "BRONZE") return "BRONZE";
  return "BRONZE";
}

export function memberRankLabelEn(key: MemberRankKey): string {
  switch (key) {
    case "SILVER":
      return "Silver";
    case "GOLD":
      return "Gold";
    case "PLATINUM":
      return "Platinum";
    default:
      return "Bronze";
  }
}

/** ネームプレート（背景グラデ・枠・文字色） */
export function rankNamePlateStyle(key: MemberRankKey): {
  background: string;
  border: string;
  nameColor: string;
  accentColor: string;
  shadow: string;
} {
  switch (key) {
    case "SILVER":
      return {
        background: "linear-gradient(135deg, #5c5c62 0%, #a8a8ae 45%, #d4d4da 100%)",
        border: "1px solid rgba(255,255,255,0.45)",
        nameColor: "#1a1a24",
        accentColor: "rgba(26,26,36,0.65)",
        shadow: "0 4px 14px rgba(180,180,190,0.35)",
      };
    case "GOLD":
      return {
        background: "linear-gradient(135deg, #8a6a1e 0%, #c9a227 40%, #f0e6a8 100%)",
        border: "1px solid rgba(255,236,160,0.55)",
        nameColor: "#1a1a2e",
        accentColor: "rgba(26,26,46,0.75)",
        shadow: "0 4px 16px rgba(212,175,55,0.45)",
      };
    case "PLATINUM":
      return {
        background: "linear-gradient(135deg, #6d7a8c 0%, #b8c4d6 42%, #eef2f8 100%)",
        border: "1px solid rgba(255,255,255,0.5)",
        nameColor: "#1a2430",
        accentColor: "rgba(26,36,48,0.7)",
        shadow: "0 4px 18px rgba(140,160,190,0.4)",
      };
    default:
      return {
        background: "linear-gradient(135deg, #5c3d22 0%, #a66b3d 42%, #cd8c5c 100%)",
        border: "1px solid rgba(255,200,160,0.35)",
        nameColor: "#fff8f0",
        accentColor: "rgba(255,248,240,0.82)",
        shadow: "0 4px 14px rgba(139,90,43,0.45)",
      };
  }
}

/** ホームのランクピル用 */
export function rankBadgePillStyle(key: MemberRankKey): { background: string; color: string; border: string } {
  switch (key) {
    case "SILVER":
      return {
        background: "linear-gradient(90deg, #6b6b70, #c8c8d0)",
        color: "#1a1a24",
        border: "1px solid rgba(255,255,255,0.35)",
      };
    case "GOLD":
      return {
        background: "linear-gradient(90deg, #b8860b, #d4af37)",
        color: "#1a1a2e",
        border: "1px solid rgba(255,236,180,0.4)",
      };
    case "PLATINUM":
      return {
        background: "linear-gradient(90deg, #7a8aa0, #dce4ee)",
        color: "#1a2430",
        border: "1px solid rgba(255,255,255,0.45)",
      };
    default:
      return {
        background: "linear-gradient(90deg, #6b4423, #b87333)",
        color: "#fff8f0",
        border: "1px solid rgba(255,200,170,0.35)",
      };
  }
}
